import Vue from "vue";

import * as App from "./app";
import Example from "./component/example.vue";
import LoadingScreenInitializer from "./initializer/loading-screen";
import MainMenuInitializer from "./initializer/mainmenu";
import SearchFieldInitializer from "./initializer/searchfield";
import SectionBlendingInitializer from "./initializer/sectionblending";
import FixedOnScrollInitializer from "./initializer/fixed-on-scroll";

const initializers = [
  new SectionBlendingInitializer(),
  new SearchFieldInitializer(),
  new MainMenuInitializer(),
  new LoadingScreenInitializer(),
  new FixedOnScrollInitializer()
];

App.boot(
  initializers,
  new Vue({
    el: "#app",
    data: {},
    components: {
      "example-component": Example
    }
  })
);
